import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from '../../components/modal';
import ReportAbuseForm from '../../components/report-abuse-form';
import { closeModal } from '../../actions/close-modal';
import withTranslate from '../../hoc/with-translate';

export const ReportCommentModal = ({ closeModal, reportComment, t }) =>
  <Modal onClose={closeModal}>
    <ReportAbuseForm
      initialValues={{ reportType: '1' }}
      onSubmit={reportComment}
      onCancel={closeModal}
      title={t('report-comment-modal.report-comment')}
      message={t('report-comment-modal.help-us-understand')}
    />
  </Modal>;

ReportCommentModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  reportComment: PropTypes.func.isRequired,
  postId: PropTypes.string.isRequired,
  commentId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      closeModal,
      reportComment: report =>
        closeModal({
          ...report,
          postId: ownProps.postId,
          commentId: ownProps.commentId,
        }),
    },
    dispatch
  );

export default connect(undefined, mapDispatchToProps)(withTranslate(ReportCommentModal));



// WEBPACK FOOTER //
// ./app/containers/report-comment-modal/report-comment-modal.js